import { useState, useEffect } from 'react';

interface UseProgressiveRenderOptions {
	delay?: number;
	enabled?: boolean;
}

export function useProgressiveRender(index: number, options: UseProgressiveRenderOptions = {}) {
	const { delay = 150, enabled = true } = options;
	const [shouldRender, setShouldRender] = useState(!enabled);

	useEffect(() => {
		if (!enabled) {
			setShouldRender(true);
			return;
		}

		const timer = setTimeout(() => {
			setShouldRender(true);
		}, index * delay);

		return () => clearTimeout(timer);
	}, [index, delay, enabled]);

	return shouldRender;
}
